"use strict";
var dataService = function() {
  function dataService($http) {
    this.$http = $http;
    this.lines = [];
    this.updating = false;
  }
  return ($traceurRuntime.createClass)(dataService, {
    load: function() {
      var $__2 = this;
      this.updating = true;
      this.$http.get("/api/unconfirmed").then(function(response) {
        $__2.lines = response.data;
        $__2.updating = false;
      }, function(error) {
        console.log("ERROR");
        $__2.updating = false;
      });
    },
    confirm: function(documents) {
      var $__2 = this;
      var data = this.convertData(documents);
      this.updating = true;
      this.$http.post("/api/unconfirmed/confirm", data).then(function() {
        return $__2.load();
      }, function() {
        $__2.updating = false;
      });
    },
    revert: function(documents) {
      var $__2 = this;
      var data = this.convertData(documents);
      if (data.length == 0)
        return;
      this.updating = true;
      this.$http.post("/api/unconfirmed/revert", data).then(function() {
        return $__2.load();
      }, function() {
        $__2.updating = false;
      });
    },
    convertData: function(documents) {
      return _.map(documents, function(l) {
        return ({
          nr: l.nr,
          archivNr: l.archivNr,
          typ: l.typ
        });
      });
    }
  }, {});
}();
dataService.$inject = ['$http'];
module.exports = dataService;
